import { render } from "./BooleanList.vue?vue&type=template&id=12439f45&scoped=true"
import script from "./BooleanList.vue?vue&type=script&lang=js"
export * from "./BooleanList.vue?vue&type=script&lang=js"

import "./BooleanList.vue?vue&type=style&index=0&id=12439f45&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12439f45"]])

export default __exports__